export default __webpack_public_path__ + "static/media/help13.75531a3f.png";